export const RedirectToUrl = (props: { url: string }) => {
  window.location.replace(props.url);
  return <></>;
};
